import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import * as signInSelectors from "store/selectors/signIn";
import { isAdmin } from "config/constants";
import { routes } from "config/routes";

type Props = {
  children: JSX.Element;
  fallback?: string;
};

export const AdminOnly = ({
  children,
  fallback = routes.private.settings,
}: Props) => {
  const { roles } = useSelector(signInSelectors.userInfo);
  if (!isAdmin(roles)) return <Navigate to={fallback} replace />;
  return children;
};
